const DropdownMenu = ({
  open,
  onClose,
  children,
  position = "top",
}: {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  position?: "top" | "bottom";
}) => {
  if (!open) return null;

  const positionClass =
    position === "bottom"
      ? "fixed end-5 bottom-[120px]"
      : "fixed end-5 top-[calc(env(safe-area-inset-top)+60px)]";

  return (
    <>
      <div
        data-action-id="menu.dismiss"
        className="fixed inset-0 z-30"
        onClick={onClose}
      />
      <div
        className={`glass-thick ${positionClass} z-50 w-60 rounded-[2rem] overflow-hidden animate-in fade-in zoom-in-95 duration-200`}
      >
        <div className="p-2 space-y-1">{children}</div>
      </div>
    </>
  );
};

export default DropdownMenu;
